<div style="width: 100%; height: 100%; padding: 24px; background: white; box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.20); border-radius: 4px; overflow: hidden; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
    <form [formGroup]="this.cancelRequest">


    <div style="align-self: stretch; height: 72px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
                <div style="align-self: stretch; justify-content: flex-start; align-items: center; display: inline-flex">
                    <mat-icon >pause_circle_outline</mat-icon>
                    <div style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
                        <div style="align-self: stretch; color: rgba(0, 0, 0, 0.87); font-size: 20px; font-family: Roboto; font-weight: 500; line-height: 32px; letter-spacing: 0.15px; word-wrap: break-word">You are about to deactivate this property </div>
                    </div>
                </div>
                <div style="align-self: stretch; height: 28px; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                    <div style="align-self: stretch; color: #444746; font-size: 16px; font-family: Roboto; font-weight: 400; line-height: 28px; letter-spacing: 0.15px; word-wrap: break-word">Please state the reason why you want inactivate it</div>
                </div>
            </div>
            <div class="form-row">
                <mat-radio-group  formControlName="option" 
                aria-labelledby="example-radio-group-label"
                class="example-radio-group">
                <mat-radio-button class="example-radio-button" [value]="1">I’m now living in the home</mat-radio-button>
                <mat-radio-button class="example-radio-button" [value]="2">I do not own the house anymore</mat-radio-button>
                <mat-radio-button class="example-radio-button" [value]="3">I have a written lease longer than 6 months</mat-radio-button>
                <mat-radio-button class="example-radio-button" [value]="4">I am no longer renting the property</mat-radio-button>
                <mat-radio-button class="example-radio-button" [value]="5">Other reason</mat-radio-button>
                <div *ngIf="this.cancelRequest.get('option')?.value == 5" class="form-row">
                  <div class="form-col">
                    <mat-form-field appearance="outline">
                      <mat-label>Reason</mat-label>
                      <input
                        matInput
                        formControlName="reason"
                        placeholder="Reason"
                      />
                      <mat-error> Reason is required</mat-error>
                    </mat-form-field>
                  </div>
                </div>
           
              </mat-radio-group>
            </div>
    
            <div style="width: 100%;" class="form-row">
                  <div class="form-col">
                <mat-form-field   [appearance]="'outline'"  >
                  <mat-label>Last date short-term rentals to remit</mat-label>
                  <input formControlName="lastDate" matInput placeholder="Provide date"  [matDatepicker]="picker"> 
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker  #picker></mat-datepicker>
                  <mat-error>Last date short-term rentals to remit is required</mat-error>
                </mat-form-field>
               </div>
       
        </div>
    </form>   
        <div style="align-self: stretch; padding: 8px; justify-content: flex-end; align-items: center; gap: 8px; display: inline-flex">
            <button (click)="dialogRef.close()" mat-stroked-button mat-button mat-dialog-close class="button-stepper-back">
                GO BACK
                <mat-icon>arrow_left_alt</mat-icon>
             </button>
             <button  (click)="deactivateProperty()"  [disabled]="!cancelRequest.valid"  mat-stroked-button
             mat-button class="button-stepper-allow"
             [ngClass]="{
                'button-stepper-allow': cancelRequest.valid,
                'button-stepper': cancelRequest.invalid
              }"
           >
           SEND REQUEST <mat-icon iconPositionEnd>send</mat-icon>
             </button>
        </div>
  
</div>